import {
  Product,
  Category,
  Video,
  SpecialOffer,
  StoreInfo,
  Review,
} from "../types";

// Mock Categories
export const mockCategories: Category[] = [
  {
    id: "1",
    name: "Action Figures",
    description: "Superheroes, characters, and collectible figures",
    icon: "🦸",
    productCount: 1,
    featured: true,
  },
  {
    id: "2",
    name: "Educational",
    description: "Learning toys and STEM activities",
    icon: "🧠",
    productCount: 4,
    featured: true,
  },
  {
    id: "3",
    name: "Vehicles",
    description: "Cars, trucks, and transportation toys",
    icon: "🚗",
    productCount: 2,
    featured: true,
  },
  {
    id: "4",
    name: "Dolls",
    description: "Dolls, playsets, and accessories",
    icon: "👸",
    productCount: 2,
    featured: true,
  },
  {
    id: "5",
    name: "Puzzles",
    description: "Brain teasers and puzzle games",
    icon: "🧩",
    productCount: 1,
    featured: true,
  },
  {
    id: "6",
    name: "Board Games",
    description: "Family games and strategy board games",
    icon: "🎲",
    productCount: 1,
    featured: true,
  },
];

// Mock Products
export const mockProducts: Product[] = [
  {
    id: "1",
    name: "Super Hero Action Figure",
    description:
      "Amazing superhero action figures featuring Mario, Luigi, and Yoshi. Perfect for imaginative play and collecting.",
    price: 2074,
    originalPrice: 2904,
    image:
      "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
    ],
    category: "Action Figures",
    categoryId: "1",
    rating: 4.8,
    reviewCount: 124,
    ageRange: "4-12 years",
    inStock: true,
    stockCount: 15,
    featured: true,
    onSale: true,
    tags: ["superhero", "action-figure", "mario", "collectible"],
    createdAt: new Date("2023-01-15"),
    updatedAt: new Date("2023-12-01"),
  },
  {
    id: "2",
    name: "Educational Building Blocks",
    description:
      "STEM learning blocks that teach coding, engineering, and problem-solving skills through hands-on play.",
    price: 3319,
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=400&h=400&fit=crop",
    ],
    category: "Educational",
    categoryId: "2",
    rating: 4.9,
    reviewCount: 89,
    ageRange: "6-14 years",
    inStock: true,
    stockCount: 8,
    featured: true,
    onSale: false,
    tags: ["stem", "educational", "building", "coding"],
    createdAt: new Date("2023-02-20"),
    updatedAt: new Date("2023-11-15"),
  },
  {
    id: "3",
    name: "Racing Car Set",
    description:
      "High-speed racing car with realistic engine sounds and LED lights. Includes track pieces for endless racing fun.",
    price: 4979,
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1562140213-0335e8b344c0?w=400&h=400&fit=crop",
    ],
    category: "Vehicles",
    categoryId: "3",
    rating: 4.7,
    reviewCount: 67,
    ageRange: "3-10 years",
    inStock: true,
    stockCount: 12,
    featured: true,
    onSale: false,
    tags: ["racing", "car", "vehicle", "remote-control"],
    createdAt: new Date("2023-03-10"),
    updatedAt: new Date("2023-10-20"),
  },
  {
    id: "4",
    name: "Princess Doll Collection",
    description:
      "Beautiful princess dolls with multiple outfits and accessories. Perfect for imaginative storytelling and dress-up play.",
    price: 2904,
    originalPrice: 3734,
    image:
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
    ],
    category: "Dolls",
    categoryId: "4",
    rating: 4.6,
    reviewCount: 93,
    ageRange: "3-8 years",
    inStock: true,
    stockCount: 6,
    featured: true,
    onSale: true,
    tags: ["princess", "doll", "dress-up", "imaginative-play"],
    createdAt: new Date("2023-04-05"),
    updatedAt: new Date("2023-09-30"),
  },
  {
    id: "5",
    name: "Science Experiment Kit",
    description:
      "Complete science kit with 50+ experiments. Learn about chemistry, physics, and biology through fun, safe experiments.",
    price: 4149,
    image:
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop",
    ],
    category: "Educational",
    categoryId: "2",
    rating: 4.8,
    reviewCount: 156,
    ageRange: "8-16 years",
    inStock: true,
    stockCount: 10,
    featured: true,
    onSale: false,
    tags: ["science", "experiment", "educational", "stem"],
    createdAt: new Date("2023-05-12"),
    updatedAt: new Date("2023-08-25"),
  },
  {
    id: "6",
    name: "Musical Keyboard Piano",
    description:
      "32-key electronic keyboard with built-in speakers, multiple instrument sounds, and recording capabilities.",
    price: 6639,
    originalPrice: 8299,
    image:
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1511379938547-c1f1981984a2?w=400&h=400&fit=crop",
    ],
    category: "Educational",
    categoryId: "2",
    rating: 4.7,
    reviewCount: 78,
    ageRange: "5-12 years",
    inStock: true,
    stockCount: 4,
    featured: true,
    onSale: true,
    tags: ["music", "keyboard", "piano", "electronic"],
    createdAt: new Date("2023-06-18"),
    updatedAt: new Date("2023-07-15"),
  },
  {
    id: "7",
    name: "Robot Building Kit",
    description:
      "Advanced robot building kit with programmable features, sensors, and multiple build options. Perfect for future engineers.",
    price: 7469,
    image:
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=400&fit=crop",
    ],
    category: "Educational",
    categoryId: "2",
    rating: 4.9,
    reviewCount: 112,
    ageRange: "10-16 years",
    inStock: true,
    stockCount: 7,
    featured: true,
    onSale: false,
    tags: ["robot", "building", "programming", "stem"],
    createdAt: new Date("2023-07-22"),
    updatedAt: new Date("2023-06-10"),
  },
  {
    id: "8",
    name: "Teddy Bear Family Set",
    description:
      "Adorable family of teddy bears in different sizes and colors. Soft, cuddly, and perfect for bedtime stories.",
    price: 2489,
    originalPrice: 3319,
    image:
      "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=400&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=400&fit=crop",
      "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop",
    ],
    category: "Dolls",
    categoryId: "4",
    rating: 4.5,
    reviewCount: 145,
    ageRange: "0-8 years",
    inStock: true,
    stockCount: 20,
    featured: true,
    onSale: true,
    tags: ["teddy-bear", "soft-toy", "family-set", "cuddly"],
    createdAt: new Date("2023-08-30"),
    updatedAt: new Date("2023-05-20"),
  },
];

// Mock Videos
export const mockVideos: Video[] = [
  {
    id: "1",
    title: "New Educational Toys Collection",
    description:
      "Discover our latest educational toys that make learning fun and engaging for kids of all ages.",
    thumbnail:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=225&fit=crop",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    category: "educational",
    duration: "5:30",
    featured: true,
    createdAt: new Date("2023-11-15"),
  },
  {
    id: "2",
    title: "Action Figures Showcase",
    description:
      "Watch our superhero action figures in action! See the amazing details and features.",
    thumbnail:
      "https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?w=400&h=225&fit=crop",
    videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    category: "action-figures",
    duration: "3:45",
    featured: true,
    createdAt: new Date("2023-10-20"),
  },
];

// Mock Special Offers
export const mockSpecialOffers: SpecialOffer[] = [
  {
    id: "1",
    title: "Diwali Offer",
    description:
      "Celebrate the festival of lights! 15% off on all items, 10% off on electric jeeps & bikes!",
    discountPercentage: 15,
    image:
      "https://images.unsplash.com/photo-1583821017783-4333717df070?w=400&h=300&fit=crop&q=80",
    validUntil: new Date("2025-12-31"),
    categoryIds: ["1", "2", "3", "4", "5", "6"],
    featured: true,
  },
  {
    id: "2",
    title: "Birthday Offer",
    description: "Get 10% off upto ₹500 on eligible purchase!",
    discountPercentage: 10,
    image:
      "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=400&h=300&fit=crop&q=80",
    validUntil: new Date("2025-12-31"),
    categoryIds: ["1", "2", "3", "4", "5", "6"],
    featured: true,
  },
  {
    id: "3",
    title: "Buy 2 Get 1 Free",
    description: "On all action figures and dolls!",
    discountPercentage: 33,
    image:
      "https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=400&h=300&fit=crop&q=80",
    validUntil: new Date("2025-12-31"),
    categoryIds: ["1", "4"],
    featured: true,
  },
];

// Mock Store Information
export const mockStoreInfo: StoreInfo = {
  name: "Benipal Toys & Gift Store",
  address: {
    street: "Badesha Road",
    city: "Khamanon",
    state: "Punjab",
    zipCode: "141801",
    country: "India",
  },
  phone: "+91 80107 24949",
  phone2: "+91 97812 53400",
  email: "benipaltoys@gmail.com",
  hours: {
    weekdays: "9:00 am to 8:30 pm",
    weekends: "9:00 am to 8:30 pm",
  },
  socialMedia: {
    instagram: "https://www.instagram.com/benipal_toys/",
    youtube: "https://www.youtube.com/channel/UCIqJtjSzBtfEu-VQeJ6R5Wg",
    whatsappChannel: "https://whatsapp.com/channel/0029VbArQQWA2pL3ZZ5sn246",
  },
};

// Mock Reviews
export const mockReviews: Review[] = [
  {
    id: "1",
    productId: "1",
    userId: "user1",
    userName: "Sarah M.",
    rating: 5,
    comment:
      "Amazing quality! My son loves playing with these action figures. Highly recommended!",
    createdAt: new Date("2023-11-20"),
  },
  {
    id: "2",
    productId: "2",
    userId: "user2",
    userName: "Mike D.",
    rating: 5,
    comment:
      "Great educational toy. My daughter learned so much while having fun building.",
    createdAt: new Date("2023-11-18"),
  },
  {
    id: "3",
    productId: "3",
    userId: "user3",
    userName: "Lisa K.",
    rating: 4,
    comment:
      "Fast delivery and great product. The car works perfectly on the track.",
    createdAt: new Date("2023-11-15"),
  },
];
